// extracted by mini-css-extract-plugin
export var PhotogallerySec = "style-module--PhotogallerySec--1WT3I";
export var gallerySection = "style-module--gallerySection--1vOMu";
export var mobilebiggerGrid = "style-module--mobilebiggerGrid--2RA_V";
export var gallery1 = "style-module--gallery1--ybl3K";
export var smallerGrid = "style-module--smallerGrid--2L4FR";
export var biggerGrid = "style-module--biggerGrid--3iPBn";